import { baseApi } from '@/lib/api/baseApi';
import { ApiResponses } from '@/types';

import { Builder } from '../commonApiType/apiBuilderTypes';
import { getMockPrivileges } from '../constants';
import { PrivilegeDetailsTypes } from './privilegeApiTypes';

export const privilegeApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    getMockPrivileges: builder.query<ApiResponses<PrivilegeDetailsTypes>, void>(
      {
        query: () => ({
          url: getMockPrivileges,
          headers: {
            Accept: 'application/json',
          },
        }),
      },
    ),
  }),
});

export const { useGetMockPrivilegesQuery, useLazyGetMockPrivilegesQuery } =
  privilegeApi;
export default privilegeApi;
